<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="1. Amaranth ‘Joseph’s Coat’">
<div class="titlepage">
<div>
<div>
<h1 class="title"><a id="d0e53" xmlns:saxon="http://icl.com/saxon">1. Amaranth
              ‘Joseph’s Coat’</a></h1><a id="d0e53" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e53" xmlns:saxon="http://icl.com/saxon">
<div>
<h3 class="subtitle">
<i>Amaranthus tricolor</i>
</h3>
</div>
</a></div><a id="d0e53" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e53" xmlns:saxon="http://icl.com/saxon">
<div class="epigraph">
<p>Following their introduction into Europe, amaranths were thought to be of such sacred
          signiﬁcance that, in 1693, Queen Christina of Sweden founded the mystical “Order of the
          Amaranth,” which survives to this day as the highest order of the Eastern Star Chapter of
          North American Masons, America’s largest Masonic women’s organization. </p>
</div>
<p>Amaranths are ancient tropical plants of diverse and surprising beauty, and are believed to
        have originated in India, although they have been grown throughout Mexico and South America
        since at least the third millennium B.C. A relative of common Lamb’s Quarters as well as the
        Garden Cockscomb, there are about sixty species of amaranth, grown either for their
        tassel-like seed heads, which are ground as a grain, or for their edible leaves, which are
        used as a potherb. Amaranths found their way into Greece very early on as well, the Greeks
        believing them to be immortal, and both this fascinating plant’s botanical and common names
        ﬁnd their root in the Greek amarantos, meaning “never-fading.” We also know that Artemis of
        Esephus, the many-breasted Greek earth goddess, regarded them as sacred.</p>
<p>The Aztec emperor Montezuma held the amaranth in such high regard that he demanded 200,000
        bushels of seed a year of it in tribute from his subjects, and in the Aztec culture, the
        amaranth was mystically associated with human sacriﬁce. This practice apparently appalled
        the conquistadores, who were fairly appalling themselves if stones are to be thrown and,
        consequently, further cultivation of amaranth in the former Aztec nation was forbidden,
        causing amaranth as a food crop to fall into obscurity on the American continent for
        hundreds of years. On other continents, however, amaranth continued to be a vegetable of
        great importance, particularly in the tropics of Africa and Asia, and today is under
        extensive cultivation in China, India, Africa, and Europe, as well as in North and South
        America.</p>
<p>In 1786, when he was ambassador to France, Thomas Jefferson included the ‘Joseph’s Coat’
        variety of amaranth in a shipment of interesting seeds to his brother-in-law Francis Eppes,
        in Virginia. A variety grown for its edible leaves, Joseph’s Coat is perhaps the most
        striking of amaranths and will certainly deliver a spectacular jolt of color to any
        vegetable garden. Its name, of course, derives from the Genesis 37 tale of Joseph’s “coat of
        many colors,” which his brothers stained red with blood in order to make his father believe
        he was dead. As gaudy as a coleus, with which it is often confused, Joseph’s Coat boasts
        almost supernaturally brilliant cadmium yellow and carmine foliage on plants growing to 4
        feet, the whole carnival of it topped with scarlet-plumed seed heads. This, in fact, is a
        plant so brazenly decorative, one is tempted to consider it far too exotically beautiful to
        be edible.</p>
<p>Being a true tropical trooper, Joseph’s Coat not only likes things hot but is incredibly
        heat, drought, and soil tolerant as well when planted in a warm, well-lit spot. Therefore,
        direct sow Joseph’s Coat seeds after last frost in a sunny (and visually prominent) place in
        your garden, thinning to 3 feet apart. The leaves, rich in vitamins A and C, calcium and
        iron, and tasting much like spinach, can be employed culinarily in much the same way as
        spinach, although, like many living things, they are best eaten when young. Additionally,
        because they will fade when cooked, why not try the tiniest leaves in a summer salad mix,
        where they will add an eye-catching note of color. Leave the rest to startle the eye in the
        garden.</p>
<div class="mediaobject" title="This is an image of Amaranth ‘Joseph’s Coat’.">
<img alt="1. Amaranth ‘Joseph’s Coat’" src="images/0a.jpg"/>
<div class="caption">
<p>Amaranth ‘Joseph’s Coat’</p>
</div>
</div>
</a></div><a id="d0e53" xmlns:saxon="http://icl.com/saxon">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02.vue?0e2ec8d7